import { formatDateTime } from '@if/core/utils'
import { ArrowBack as ArrowBackIcon, Refresh as RefreshIcon } from '@mui/icons-material'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Paper,
  Typography,
} from '@mui/material'
import type { JSX } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useAppDispatch } from '../../../data/store'
import { appActions } from '../../../data/store/AppStore/app-store'
import { Conflict } from '../../../data/types/Conflict'

interface Props {
  conflict: Conflict | null
  open: boolean
}

const ConflictDialog = ({ conflict, open }: Props): JSX.Element => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  return (
    <Paper>
      <Dialog open={open} fullWidth onClose={() => dispatch(appActions.setConflict(null))}>
        <DialogTitle>{t('conflict.modificationConflict')}</DialogTitle>
        <Divider />

        <DialogContent>
          <DialogContentText>
            <Typography marginBottom={2}>
              <Trans
                i18nKey="conflict.cantSaveModifiedBy"
                values={{
                  userFullName: conflict?.userFullName,
                  updatedOn: formatDateTime(conflict?.updatedOn),
                }}
              />
            </Typography>
            <Typography>{`${t('conflict.closeOrReload')}.`}</Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => dispatch(appActions.setConflict(null))}
            startIcon={<ArrowBackIcon />}
          >
            {t('conflict.backToWork')}
          </Button>
          <Button
            variant="contained"
            color="warning"
            onClick={() => window.location.reload()}
            startIcon={<RefreshIcon />}
          >
            {t('conflict.reloadPage')}
          </Button>
        </DialogActions>
      </Dialog>
    </Paper>
  )
}

export default ConflictDialog
